module.exports = __webpack_public_path__ + "static/img/gyl1.dd23bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gyl1.png
// module id = HOP+
// module chunks = 1